import { useMemo } from 'react';
import type { LanguagePickerItem } from 'voyager';
import languageOptions from '@common/components/Menu/Items/LanguageMenu/languageOptions';
import { changeLanguage } from './changeLanguage';

const REGION_BY_LANGUAGE: Record<string, string> = {
  en: 'United Kingdom',
  ca: 'Catalunya',
  de: 'Deutschland',
  fr: 'France',
  es: 'España',
  it: 'Italia',
  nl: 'Nederland',
  pl: 'Polska',
  pt: 'Portugal',
  ru: 'Россия',
};

interface UseLanguagePickerItemsArgs {
  availableLanguages: string[];
  currentLanguage: string;
}

export function useLanguagePickerItems({
  availableLanguages,
  currentLanguage,
}: UseLanguagePickerItemsArgs): LanguagePickerItem[] {
  return useMemo(() => {
    return availableLanguages
      .map((code): LanguagePickerItem | null => {
        const option = languageOptions[code as keyof typeof languageOptions];
        if (!option) return null;
        return {
          code,
          name: option.label.text,
          region: REGION_BY_LANGUAGE[code],
          active: code === currentLanguage,
          onSelect: () => {
            if (code === currentLanguage) return;
            changeLanguage(code);
          },
        };
      })
      .filter((item): item is LanguagePickerItem => item !== null);
  }, [availableLanguages, currentLanguage]);
}
